export const createSettingValue = (tupleValue, tupleWasm, configWasm) => {
    return new SettingValueImpl(tupleValue, tupleWasm, configWasm);
};
class SettingValueImpl {
    tupleValue;
    tupleWasm;
    configWasm;
    constructor(tupleValue, tupleWasm, configWasm) {
        this.tupleValue = tupleValue;
        this.tupleWasm = tupleWasm;
        this.configWasm = configWasm;
    }
    rawValue() {
        return this.tupleValue;
    }
    asBoolean() {
        const uint32 = this.asUint32();
        return uint32 === 1;
    }
    asOptionalBoolean() {
        const uint32 = this.asUint32();
        return uint32;
    }
    asUint32() {
        return this.tupleWasm.getUint32FromTuple(this.tupleValue);
    }
    asUint64() {
        return this.tupleWasm.getUint64FromTuple(this.tupleValue);
    }
    asString() {
        return this.tupleWasm.getStringFromTuple(this.tupleValue);
    }
    asBytes() {
        return this.tupleWasm.getByteArrayFromStringTuple(this.tupleValue);
    }
    asMultiString() {
        const tuple = this.tupleWasm.getTupleFromTuple(this.tupleValue);
        return this.tupleWasm.getMultiStringFromTuple(tuple);
    }
    toString() {
        return this.configWasm.rawSettingValueToString(this.tupleValue);
    }
}
